import { Grid } from "@mui/material";
import { FormikProps } from "formik";
import AsyncSelect from "@/components/AsyncSelect";
import Flex from "@/components/Flex";
import Text from "@/components/Text";
import ValueSwitcher from "@/components/ValueSwitcher";
import { NEW_APPOINTMENT_VISIT_TYPE } from "@/constants/scheduling";
import { GROUP_FIELDS_LABEL, VISIT_MODE } from "../group-visit-constant";
import { GroupFieldsValues, VisitMode } from "../group-visit-types";
import { useGroupSessionOptions } from "../hooks/use-group-session-options";

export type GroupSessionFieldsProps = {
  formik: FormikProps<GroupFieldsValues>;
  disabled?: boolean;
  /** Availability depends on these, so a picked slot must be dropped. */
  onAvailabilityChange: () => void;
};

/** Visit Type and Location — the slot search inputs. */
const GroupSessionFields = ({
  formik,
  disabled,
  onAvailabilityChange,
}: GroupSessionFieldsProps) => {
  const { values, errors, touched, setFieldValue, handleBlur } = formik;
  const { locationOptions, onSearchLocation } = useGroupSessionOptions();
  const isInPerson = values.mode === VISIT_MODE.IN_PERSON;

  return (
    <Grid container spacing={2}>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Flex alignItems="center" gap={1}>
          <Text>{GROUP_FIELDS_LABEL.visitType}</Text>
          <ValueSwitcher
            alignment={values.mode}
            timing={NEW_APPOINTMENT_VISIT_TYPE}
            handleChange={(_, value) => {
              if (!value) return;
              setFieldValue("mode", value as VisitMode);
              setFieldValue("locationId", null);
              onAvailabilityChange();
            }}
          />
        </Flex>
      </Grid>

      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <AsyncSelect
          required={isInPerson}
          name="locationId"
          label={GROUP_FIELDS_LABEL.location}
          options={locationOptions}
          value={values.locationId}
          disabled={disabled}
          onSearch={onSearchLocation}
          handleBlur={handleBlur}
          onChange={(value) => {
            setFieldValue("locationId", value);
            onAvailabilityChange();
          }}
          error={touched.locationId && (errors.locationId as string)}
        />
      </Grid>
    </Grid>
  );
};

export default GroupSessionFields;
